<div class="event-card" [ngClass]="event.type">
  <div class="event-info">
    <div class="event-info-header">
      <span class="event-type">
        {{ typesMap[event.type] | translate }}
      </span>
      <span class="event-date">
        {{ (event.type === types.LEARNING_PATH_DEADLINE ? (event.date | dateWithoutTimezone) : event.date) | customDate : 'short' }}
        <span class="event-date-separator"></span>
        {{ (event.type === types.LEARNING_PATH_DEADLINE ? (event.date | dateWithoutTimezone) : event.date) | customDate : 'shortTime' }}
      </span>
    </div>

    <div class="event-info-body">
      <h5 class="event-title">
        {{ event.name }}
      </h5>
    </div>


    <div class="event-info-footer">
      @if (event.type === types.CUSTOM) {
        <button
          mat-flat-button
          class="button button--border"
          (click)="openDetailsDialog()">
          {{ 'LEARNER_CALENDAR.see_event_details' | translate }}
        </button>
      }

      @if (relatedEntityLink) {
        <a
          mat-flat-button
          class="button button--secondary"
          (click)="navigate()"
          data-cy="event-entity-link">
          <lib-icon icon="arrow-square-out"></lib-icon>
          {{ 'LEARNER_CALENDAR.open' | translate }}
        </a>
      }

      @if (event.type === types.WEBINAR || event.type === types.IN_PERSON) {
        <lib-event-registration-buttons
          [webinar]="$any(event.relatedEntity)"
          [inline]="true"
          (joined)="onJoin()">
        </lib-event-registration-buttons>
      }

      @if (showAttendingButton) {
        <button
          mat-flat-button
          class="button button--primary"
          [disabled]="isLoading"
          (click)="updateEventAttendance()">
          <lib-icon [icon]="attending ? 'check-circle' : 'plus-circle'"></lib-icon>
          {{ attendeeButtonLabel | translate }}
        </button>
      }

      @if (cardsSettings?.event?.addToCalendar?.visible) {
        <lib-icon-button
          class="d-block mr-2"
          icon="calendar-check"
          [exportCalendar]="exportCalendarEvent"
          [ariaLabel]="'Add to calendar'"
          [tooltip]="'COMMON.add_to_calendar' | translate"
          tooltipPosition="above">
        </lib-icon-button>
      }
    </div>
  </div>

  @if (event.mediaImage) {
    <div
      class="event-image"
      [cropImage]="event.mediaImage | preSignedUrl | async"
    [additionalOptions]="{ width: 400 }"></div>
  } @else {
    <div class="event-image default" [ngStyle]="{ backgroundImage: $any(event) | offlineActivityImage }"></div>
  }

</div>
